import React from 'react';
import parse from 'html-react-parser';
import Image from 'js/components/Common/Image/Image';
import Heading from 'js/components/Common/Heading/Heading';

import classes from './MainTab.module.pcss';
import LearningPathStore from 'js/store/LearningPathStore';
import {observer} from 'mobx-react';

interface Props {
    index: 'first_item' | 'second_item',
	clickHandler: Function,
	title: string,
	description: string,
	image: string,
	disabled: boolean
}

const MainTab = ({index, title, description, image, clickHandler, disabled = false}: Props) => (
	<div onClick={() => !disabled ? clickHandler(index) : () => {}}
		 className={`${classes.MainTab} ${LearningPathStore.activeMainTab === index ? classes.Active : ''} ${disabled ? classes.Disabled : ''}`}>
		<div className={classes.Inner}>
			<Image
				mediaItemUrl={image}
				alt={title}/>
			<Heading text={title} type={'h4'}/>
			<div className={classes.Description}>
				{parse(description || '')}
			</div>
		</div>
	</div>
);

export default observer(MainTab);
